import { EmptyTableState } from '@/modules/common/components/EmptyTableState';
import { getDefaultMRTOptions } from '@/modules/common/lib/react-material-table';
import { IUser, IUserWithProfile } from '@/types/user';
import {
  MRT_TableOptions,
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { getTeamMembersTableColumns } from './TeamMembersTable.columns';

export type TeamMembersTableProps = {
  tableOptions: Omit<MRT_TableOptions<IUserWithProfile>, 'columns'>;
  learningBudgetLimit?: number;
  onSetLearningBudget?: (member: IUser) => void;
  onRemoveMember?: (member: IUser) => void;
};

const defaultMRTOptions = getDefaultMRTOptions<IUserWithProfile>();

export function TeamMembersTable({
  tableOptions,
  learningBudgetLimit,
  onSetLearningBudget,
  onRemoveMember,
}: TeamMembersTableProps) {
  const table = useMaterialReactTable<IUserWithProfile>({
    ...defaultMRTOptions,
    manualPagination: false,
    columns: getTeamMembersTableColumns({
      learningBudgetLimit,
      onSetLearningBudget,
      onRemoveMember,
    }),
    muiTableHeadProps: {
      sx: {
        display: tableOptions.data.length ? undefined : 'none',
      },
    },
    renderEmptyRowsFallback: ({ table }) => {
      const { columnFilters, globalFilter } = table.getState();
      const hasFilters =
        globalFilter ||
        columnFilters.some(columnFilter =>
          Array.isArray(columnFilter.value)
            ? columnFilter.value.length
            : columnFilter.value,
        );

      return (
        <EmptyTableState
          hasFilters={hasFilters}
          emptyStateImage="/images/no-people.png"
          emptyStateTitle="Team members"
          emptyStateMessage="Your invited team members will be displayed here once added."
        />
      );
    },
    ...tableOptions,
  });

  return <MaterialReactTable table={table} />;
}
